import { RotateCcw } from 'lucide-react';

import { Button } from '../../../../components/ui/button';

interface UndoDeleteToastProps {
  countdown: number;
  count: number;
  kind: 'images' | 'quotes' | 'files';
  onUndo: () => void;
}

const getKindNoun = (kind: UndoDeleteToastProps['kind'], isPlural: boolean) => {
  if (kind === 'images') return isPlural ? 'imágenes' : 'imagen';
  if (kind === 'quotes') return isPlural ? 'cotizaciones' : 'cotización';
  return isPlural ? 'archivos' : 'archivo';
};

const kindLabel = (kind: UndoDeleteToastProps['kind'], count: number) => {
  if (count === 1) return `1 ${getKindNoun(kind, false)}`;
  return `${count} ${getKindNoun(kind, true)}`;
};

const UndoDeleteToast = ({ countdown, count, kind, onUndo }: UndoDeleteToastProps) => (
  <div className="flex flex-col gap-2 rounded-lg border border-neutral-200 bg-brand-light px-4 py-3">
    <div className="flex items-center justify-between gap-4">
      <div className="flex min-w-0 items-center gap-3">
        <span className="flex size-8 shrink-0 items-center justify-center rounded-full bg-brand-vivid text-sm font-bold text-white">
          {countdown}
        </span>
        <p className="text-sm text-text-default">
          <span className="font-semibold">{kindLabel(kind, count)}</span>{' '}
          {count === 1 ? 'se eliminará' : 'se eliminarán'}
          {` en ${countdown}s. Recupera antes.`}
        </p>
      </div>
      <Button className="shrink-0" onClick={onUndo} size="sm" type="button">
        <RotateCcw className="size-3.5" />
        Recuperar
      </Button>
    </div>
    <div className="h-1 w-full overflow-hidden rounded-full bg-neutral-200">
      <div
        className="h-full rounded-full bg-brand-vivid transition-all duration-1000"
        style={{ width: `${(countdown / 10) * 100}%` }}
      />
    </div>
  </div>
);

export default UndoDeleteToast;
